module.exports = __webpack_public_path__ + "static/certnz-logo-39137e95d60b8007b55aa543b21d92db.png";